import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-ticket-header" }
const _hoisted_2 = {
  key: 0,
  class: "edit-ticket-header__buttons"
}
const _hoisted_3 = {
  key: 1,
  class: "edit-ticket-header__title"
}
const _hoisted_4 = {
  key: 2,
  class: "edit-ticket-header__buttons"
}

import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import { computed } from 'vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import DividerVertical from '@/design-system/atoms/DividerVertical.vue'
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'

interface EMITS {
  (e: 'archiveTicket'): void
  (e: 'closeEditTicketModal', value: boolean): void
  (e: 'deleteTicket'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EditTicketHeader',
  props: {
    loadingTicket: { type: Boolean }
  },
  emits: ["archiveTicket", "closeEditTicketModal", "deleteTicket"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const { t } = useI18n()
const piniaStore = useGeneralStore()
const store = useStore()

const isLoadingTicket = computed(() => props.loadingTicket)
const selectedTicket = computed(() => piniaStore.selectedTicket)

function closeModal() {
  piniaStore.setSelectedTicket(null)
  emits('closeEditTicketModal', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (isLoadingTicket.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(ButtonText, {
            class: "edit-ticket-header__buttons__button",
            iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
            size: "extra-small",
            onOnClicked: closeModal
          }, null, 8, ["iconLeft"])
        ]))
      : _createCommentVNode("", true),
    (!isLoadingTicket.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(selectedTicket.value?.title ?? ''), 1))
      : _createCommentVNode("", true),
    (!isLoadingTicket.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          (_unref(store).getters.hasErrandAdminAccess && selectedTicket.value?.active)
            ? (_openBlock(), _createBlock(TooltipStandardV2, {
                key: 0,
                text: _unref(t)('general__text__delete'),
                arrowPosition: 'top-center',
                verticalOffset: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonText, {
                    class: "edit-ticket-header__buttons__button",
                    iconLeft: require('@/design-system/assets/icons/Icon-Trash-2-small.svg'),
                    size: "extra-small",
                    onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (emits('deleteTicket')))
                  }, null, 8, ["iconLeft"])
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (_unref(store).getters.hasErrandEditorAccess && selectedTicket.value?.active)
            ? (_openBlock(), _createBlock(TooltipStandardV2, {
                key: 1,
                text: _unref(t)('general__text__archive'),
                arrowPosition: 'top-center',
                verticalOffset: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonText, {
                    class: "edit-ticket-header__buttons__button",
                    iconLeft: require('@/design-system/assets/icons/Icon-Archive-Small.svg'),
                    size: "extra-small",
                    onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('archiveTicket')))
                  }, null, 8, ["iconLeft"])
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (selectedTicket.value?.active)
            ? (_openBlock(), _createBlock(DividerVertical, {
                key: 2,
                style: {"margin":"0 8px"}
              }))
            : _createCommentVNode("", true),
          _createVNode(ButtonText, {
            class: "edit-ticket-header__buttons__button",
            iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
            size: "extra-small",
            onOnClicked: closeModal
          }, null, 8, ["iconLeft"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})